import { Link } from "react-router-dom";
import { useI18n } from "@/lib/i18n";
import PixoSprite from "@/components/pixo/PixoSprite";
import Seo from "@/components/Seo";

/** 404: Pixie got lost. */
export default function NotFound() {
  const { t } = useI18n();
  const N = t.notfound;
  return (
    <div className="pt-28 pb-24 px-5 max-w-xl mx-auto text-center flex flex-col items-center" data-testid="not-found">
      <Seo noindex title={"Página não encontrada"} />
      <div className="font-display font-black text-[96px] sm:text-[128px] leading-none text-amber-400/20 tabular-nums select-none">404</div>
      <div className="-mt-14 sm:-mt-20 notfound-wander">
        <PixoSprite gem="quartzo" equipped={{}} pose="idle" scale={4} />
      </div>
      <h1 className="font-display text-4xl sm:text-5xl font-black uppercase tracking-tight mt-2">{N.title}</h1>
      <p className="text-stone-400 mt-3 max-w-md">{N.text}</p>
      <div className="flex gap-2 mt-6 flex-wrap justify-center">
        <Link to="/" className="btn-gold px-5 py-3 text-[11px] font-bold uppercase tracking-[0.18em] rounded-sm">{N.home}</Link>
        <Link to="/stores" className="border border-amber-500/40 text-amber-200 hover:bg-amber-500/10 px-5 py-3 text-[11px] font-bold uppercase tracking-[0.18em] rounded-sm">{N.rankings}</Link>
      </div>
    </div>
  );
}
